import React from 'react';
import styled from 'styled-components';
import { reportError } from '@this/lib/bugsnag';
import type User from '../../../../../domain/user/user';
import type { WorkflowTypeKeys } from '../../departments';

interface Props<T extends WorkflowTypeKeys> {
  members: User[];
  onSelect: (i: number, s: number, member: any, workflowType?: T) => void;
  i: number;
  s: number;
  workflowType?: T;
  // department: Department;
  selectedMembers: User[];
  isDeletableApprover?: (i: number, s: number, workflowType?: T) => boolean;
}

interface State {
  filteredMembers: User[];
}

class ApproversMemberList<T extends WorkflowTypeKeys> extends React.Component<Props<T>, State> {
  private searchTextInput: React.RefObject<HTMLInputElement>;

  constructor(props: Props<T>) {
    super(props);
    this.state = {
      filteredMembers: this.props.members
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearchMembers = this.handleSearchMembers.bind(this);
    this.searchTextInput = React.createRef();
  }

  componentDidMount() {
    if (this.searchTextInput.current) {
      this.searchTextInput.current.focus();
    }
  }

  handleSelect(member: User | null) {
    this.props.onSelect(this.props.i, this.props.s, member, this.props.workflowType);
  }

  handleSearchMembers(e: React.ChangeEvent<HTMLInputElement>) {
    const keyword = e.target.value;
    const filtered = this.props.members.filter(
      member =>
        member.name.toLowerCase().indexOf(keyword) >= 0 ||
        member.nameRoman().toLowerCase().indexOf(keyword) >= 0 ||
        member.email.indexOf(keyword) >= 0
    );
    this.setState({ filteredMembers: filtered });
  }

  isDeletable = (): boolean => {
    if (this.props.isDeletableApprover !== undefined) {
      return this.props.isDeletableApprover(this.props.i, this.props.s, this.props.workflowType);
    }
    return false;
  };

  render() {
    try {
      return (
        <div className="select-approvers">
          <ApproverMembersList className="approver-members-list">
            <input
              type="search"
              defaultValue=""
              placeholder="社員名またはemailで検索"
              onChange={this.handleSearchMembers}
              ref={this.searchTextInput}
            />
            <ul>
              {this.isDeletable() && (
                <ApproverMembersListMessage
                  className="approver-members-list__message"
                  onClick={() => this.handleSelect(null)}
                >
                  <ApproverMembersListMessageInfo className="approver-members-list__message__info">
                    <ApproverMembersListMessageName className="approver-members-list__message__name">
                      選択してください
                    </ApproverMembersListMessageName>
                  </ApproverMembersListMessageInfo>
                </ApproverMembersListMessage>
              )}
              {this.state.filteredMembers.map((member, i) => (
                <ApproverMembersListItem
                  key={`approver_${i}_${this.props.i}_${this.props.s}`}
                  className={
                    this.props.selectedMembers.indexOf(member) >= 0
                      ? 'approver-members-list__item selected'
                      : 'approver-members-list__item'
                  }
                  onClick={() => this.handleSelect(member)}
                  selected={this.props.selectedMembers.indexOf(member) >= 0}
                >
                  <ApproverMembersListItemInfo className="approver-members-list__item__info">
                    {member.departmentName() && (
                      <ApproverMembersListItemName className="approver-members-list__item__name">
                        {member.departmentName()}
                      </ApproverMembersListItemName>
                    )}
                    <ApproverMembersListItemName className="approver-members-list__item__name">
                      {member.name}
                    </ApproverMembersListItemName>
                    <ApproverMembersListItemName className="approver-members-list__item__name">
                      ({member.email})
                    </ApproverMembersListItemName>
                  </ApproverMembersListItemInfo>
                </ApproverMembersListItem>
              ))}
            </ul>
          </ApproverMembersList>
        </div>
      );
    } catch (e) {
      reportError(e);
      return null;
    }
  }
}

const ApproverMembersList = styled.div`
  z-index: 10;
  margin: 0;
  position: absolute;
  width: 100%;
  background-color: ${props => props.theme.fieldBgColor};

  input[type='search'] {
    margin: 0;
  }
`;

const ApproverMembersListMessage = styled.li`
  width: 100%;
  border: 2px solid ${props => props.theme.grayBorderColor};
  margin: 0;
  cursor: pointer;
`;

const ApproverMembersListMessageInfo = styled.div`
  display: inline-block;
  flex-wrap: wrap;
  width: 97%;
  padding: 5px;
`;

const ApproverMembersListMessageName = styled.p`
  margin-right: 10px;
  display: inline-block;
`;

const ApproverMembersListItem = styled.li<{ selected: boolean }>`
  width: 100%;
  border: 2px solid ${props => props.theme.grayBorderColor};
  margin: 0;
  cursor: ${props => (props.selected ? 'default' : 'pointer')};
  background: ${props => props.selected && props.theme.grayBorderColor};
`;

const ApproverMembersListItemInfo = styled.div`
  display: inline-block;
  flex-wrap: wrap;
  width: 97%;
  padding: 5px;
`;

const ApproverMembersListItemName = styled.p`
  margin-right: 10px;
  display: inline-block;
`;

export default ApproversMemberList;
